function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.76249 0.0666504H15.2375C15.7709 0.0666504 16.2 0.487008 16.2 1.00951V1.95237C16.2 2.47487 15.7709 2.89522 15.2375 2.89522H1.76249C1.2291 2.89522 0.799988 2.47487 0.799988 1.95237V1.00951C0.799988 0.487008 1.2291 0.0666504 1.76249 0.0666504ZM4.42541 11.0863L7.05624 8.50915V16.7238C7.05624 17.2463 7.48535 17.6667 8.01874 17.6667H8.98124C9.51462 17.6667 9.94374 17.2463 9.94374 16.7238V8.50915L12.5746 11.0863C12.9516 11.4556 13.5611 11.4556 13.9341 11.0863L14.6159 10.4184C14.9929 10.0492 14.9929 9.45201 14.6159 9.08665L9.18176 3.76344C8.80478 3.39415 8.1952 3.39415 7.82223 3.76344L2.3841 9.08665C2.00712 9.45594 2.00712 10.0531 2.3841 10.4184L3.06587 11.0863C3.44285 11.4556 4.05244 11.4556 4.42541 11.0863Z",
  fill: "#FCFCFC"
});

var SvgBackToTop = function SvgBackToTop(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBackToTop, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/back-to-top.7e4031d8.svg";
export { ForwardRef as ReactComponent };